import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { SectoresService } from './services/sectores.service';
import { ISector, ISectorRequest, ISectorResponse } from './interfaces/sector.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sectores',
  templateUrl: './sectores.component.html',
  providers: [MessageService]
})
export class SectoresComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedSector: ISector | null = null;
  dataSource: ISector[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'sector', header: 'Sector', sortable: true },
    { field: 'descripcion', header: 'Descripción', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private sectoresService: SectoresService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    const request: ISectorRequest = {
      que: 4,
      tope: '9999',
      sector: '',
      descripcion: '',
      fechaAlta: '',
      responsable: ''
    };

    this.sectoresService.getSectores(request).subscribe({
      next: (response: ISectorResponse) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los sectores'
          });
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los sectores'
        });
        console.error('Error:', error);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openCreate(): void {
    this.selectedSector = null;
    this.displayDialog = true;
  }

  openUpdate(row: ISector): void {
    this.selectedSector = { ...row };
    this.displayDialog = true;
  }

  openDelete(row: ISector): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este sector?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.sectoresService.deleteSector(row.sector).subscribe({
          next: (response) => {
            if (response.success && response.data) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Sector eliminado correctamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar el sector'
              });
            }
          },
          error: (error) => {
            console.error('Error:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar el sector'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.selectedSector = null;
    this.displayDialog = false;
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.loadData();
  }
}
